import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';
import React from 'react';

export const Promotion = Styled(
	createSvgIcon(
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M3.32408 12.217L2.05742 10.9503C1.54076 10.4337 1.54076 9.58365 2.05742 9.06698L3.32408 7.8003C3.54075 7.58363 3.71575 7.15863 3.71575 6.85863V5.06694C3.71575 4.33361 4.31575 3.73363 5.04909 3.73363H6.84075C7.14075 3.73363 7.56575 3.55865 7.78242 3.34199L9.04908 2.07531C9.56574 1.55864 10.4158 1.55864 10.9324 2.07531L12.1991 3.34199C12.4158 3.55865 12.8407 3.73363 13.1407 3.73363H14.9324C15.6658 3.73363 16.2657 4.33361 16.2657 5.06694V6.85863C16.2657 7.15863 16.4407 7.58363 16.6574 7.8003L17.9241 9.06698C18.4408 9.58365 18.4408 10.4337 17.9241 10.9503L16.6574 12.217C16.4407 12.4337 16.2657 12.8587 16.2657 13.1587V14.9503C16.2657 15.6836 15.6658 16.2837 14.9324 16.2837H13.1407C12.8407 16.2837 12.4158 16.4587 12.1991 16.6753L10.9324 17.942C10.4158 18.4587 9.56574 18.4587 9.04908 17.942L7.78242 16.6753C7.56575 16.4587 7.14075 16.2837 6.84075 16.2837H5.04909C4.31575 16.2837 3.71575 15.6836 3.71575 14.9503V13.1587C3.71575 12.8503 3.54075 12.4253 3.32408 12.217Z'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M7.5 12.5L12.5 7.5'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M12.0788 12.0834H12.0863'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M7.91209 7.91667H7.91957'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>,
		'Promotion'
	)
);

export default Promotion;
